import React, { useContext, useMemo, useState } from 'react';

interface NotificationsPanelContextType {
  isOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
}

const NotificationsPanelContext = React.createContext<
  NotificationsPanelContextType | undefined
>(undefined);

interface NotificationsPanelProviderProps {
  children: React.ReactNode;
}

export function NotificationsPanelProvider({
  children,
}: NotificationsPanelProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(
    () => ({
      isOpen,
      openPanel: () => setIsOpen(true),
      closePanel: () => setIsOpen(false),
    }),
    [isOpen],
  );

  return (
    <NotificationsPanelContext.Provider value={value}>
      {children}
    </NotificationsPanelContext.Provider>
  );
}

export function useNotificationsPanel(): NotificationsPanelContextType {
  const context = useContext(NotificationsPanelContext);
  if (context === undefined) {
    throw new Error(
      'useNotificationsPanel hook must be used within a NotificationsPanelProvider.',
    );
  }

  return context;
}
